var _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#5E86A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6664 37.4265C39.7547 37.4265 43.8796 33.3016 43.8796 28.2132C43.8796 23.1249 39.7547 19 34.6664 19C29.578 19 25.4531 23.1249 25.4531 28.2132C25.4531 33.3016 29.578 37.4265 34.6664 37.4265Z",
    stroke: "#64C1C6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9992 54.5576C51.9992 45.0571 44.5616 38.1092 35.0071 38.1092C25.4527 38.1092 18.5586 45.4485 18.5586 54.5576",
    stroke: "#64C1C6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 27,
    stroke: "#64C1C6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.62344b8808fcf58ac784303218e892cc.svg";
export { ForwardRef as ReactComponent };